// should be kept in sync with ppn marketplace data
// https://github.com/porsche-customer/slsystem-ppn-service/blob/master/ppnMarketplaceData/stages/prod.ts
export const allCountries = [
	"AE", // Abu Dhabi
	"AM", // Armenia
	"AR", // Argentina
	"AT", // Austria
	"AU", // Australia
	"AZ", // Azerbaijan
	"BA", // Bosnia and Herzegovina
	"BE", // Belgium
	"BG", // Bulgaria
	"BH", // Bahrain
	"BN", // Brunei
	"BO", // Bolivia
	"BR", // Brazil
	"CA", // Canada
	"CH", // Switzerland
	"CL", // Chile
	"CN", // China
	"CO", // Colombia
	"CR", // Costa Rica
	"CW", // Curaçao
	"CY", // Cyprus
	"CZ", // Czech Republic
	"DE", // Germany
	"DK", // Denmark
	"DO", // Dominican Republic
	"DU", // Dubai (special case)
	"EC", // Ecuador
	"EE", // Estonia
	"EG", // Egypt
	"ES", // Spain
	"FI", // Finland
	"FR", // France
	"GB", // United Kingdom
	"GE", // Georgia
	"GP", // Guadeloupe
	"GR", // Greece
	"GT", // Guatemala
	"HK", // Hong Kong
	"HN", // Honduras
	"HR", // Croatia
	"HU", // Hungary
	"ID", // Indonesia
	"IE", // Ireland
	"IL", // Israel
	"IN", // India
	"IS", // Iceland
	"IT", // Italy
	"JM", // Jamaica
	"JO", // Jordan
	"JP", // Japan
	"KH", // Cambodia
	"KR", // South Korea
	"KW", // Kuwait
	"KZ", // Kazakhstan
	"LB", // Lebanon
	"LK", // Sri Lanka
	"LT", // Lithuania
	"LU", // Luxembourg
	"LV", // Latvia
	"MA", // Morocco
	"MC", // Monaco
	"MD", // Moldova
	"MK", // Macedonia
	"MN", // Mongolia
	"MT", // Malta
	"MU", // Mauritius
	"MX", // Mexico
	"MY", // Malaysia
	"NC", // New Caledonia
	"NL", // Netherlands
	"NO", // Norway
	"NZ", // New Zealand
	"OM", // Oman
	"PA", // Panama
	"PE", // Peru
	"PF", // French Polynesia
	"PH", // Philippines
	"PL", // Poland
	"PR", // Puerto Rico
	"PT", // Portugal
	"PY", // Paraguay
	"QA", // Qatar
	"RE", // Réunion
	"RO", // Romania
	"RS", // Serbia
	"SA", // Saudi Arabia
	"SG", // Singapore
	"SI", // Slovenia
	"SK", // Slovakia
	"SV", // El Salvador
	"TH", // Thailand
	"TN", // Tunisia
	"TR", // Turkey
	"TT", // Trinidad and Tobago
	"TW", // Taiwan
	"UA", // Ukraine
	"US", // United States
	"UY", // Uruguay
	"UZ", // Uzbekistan
	"VN", // Vietnam
	"XA", // Abu Dhabi (special case)
	"XD", // Dubai (special case)
	"XP", // Porsche Werkswagen (special case)
	"ZA", // South Africa
] as const

export type Country = (typeof allCountries)[number]
